var emailBlast = angular.module("emailBlast", ["classy", "emailBlastArchive", 
    "emailBlastRecipients", "ngSanitize"]);